module.exports = __webpack_public_path__ + "static/media/29ADMSPC2.71e5a2d1.jpg";